export const getActive = (id, data) => {
  const instance = data.filter(item => (item._id === id))
  if (instance.length === 0) return false
  return instance[0].active
}
